export default function formatoCPF(cpf) {
 const filtroCpf = cpf.replace(/\D/g, '');

  if (filtroCpf.length !== 11) {
    return filtroCpf;
  }

  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}
